module.exports = __webpack_public_path__ + "static/media/2.cfb863e2.jpg";